@use '../../styling/typography.scss' as *;
@use '../../styling/colors.scss' as *;

.TrackerBadge {
  @extend %font-family-primary;

  font-size: $font-size-small;
  font-weight: $font-weight-semibold;
  border-radius: 4px;
  height: 16px;
  display: inline-flex;

  &.filter {
    align-items: center;
    background: $color-primary-purple;
    color: $color-white;
    border: 1px $color-primary-purple solid;
    display: flex;
    height: 14px;
    justify-content: center;
    padding: 2px 3px;
    min-width: 12px;
    max-width: 25px; /* min-max required to render 2 and 3 digits filter */
    max-height: 20px;
  }

  &.error,
  &.grey,
  &.warning {
    align-items: center;
    color: $color-white;
    display: flex;
    height: 16px;
    justify-content: center;
    padding: 0 4px;
    min-width: 12px;
    max-width: 45px; /* min-max required to render 5 digits filter */
    box-sizing: border-box;
    flex-shrink: 0;
  }

  &.error {
    background: $color-primary-red;
  }

  &.grey {
    background: $color-primary-purple-5;
    color: $color-grey-light-text;
  }

  &.warning {
    background: $color-warning-orange;
  }

  &.tag {
    background: $theme-color-secondary-button-background;
    border: 1px $theme-color-secondary-button-background solid;
    padding: 2px 6px;
    color: $theme-color-tag-font;

    &:hover {
      background: $theme-color-secondary-button-hover;
      border: 1px $theme-color-secondary-button-hover solid;
      cursor: pointer;
    }
  }

  &.small {
    min-width: max-content;
    width: 10px;
    height: 12px;
  }
}
